import React from "react";
import "./InfoFragmentImage.scss";
import boat from "../../../../../assets/svg/boat.svg";
import car from "../../../../../assets/svg/car.svg";
import cow from "../../../../../assets/svg/cow.svg";
import deer from "../../../../../assets/svg/deer.svg";
import ice from "../../../../../assets/svg/ice.svg";
import iceCream from "../../../../../assets/svg/icecream.svg";
import iceSkaters from "../../../../../assets/svg/iceskaters.svg";
import snow from "../../../../../assets/svg/snow.svg";
import tulip from "../../../../../assets/svg/tulip.svg";
import zopie from "../../../../../assets/svg/zopie.svg";

export type YearInfoContentImage = 'boat' | 'car' | 'cow' | 'deer' | 'ice' | 'iceCream' | 'iceSkaters' | 'snow' | 'tulip' | 'zopie';

interface IProps {
    image: YearInfoContentImage;
    position: 'left' | 'right';
}

const images = {
    boat,
    car,
    cow,
    deer,
    ice,
    iceCream,
    iceSkaters,
    snow,
    tulip,
    zopie,
}

export function InfoFragmentImage(props: IProps) {
    return (
        <div className={`info-fragment-image-wrapper image-${props.position}`}>
            <img src={images[props.image]} alt={props.image} />
        </div>
    )
}
